import { withInstall } from '../../utils';
import Dialog from './src/dialog.vue';

export const IDialog = withInstall(Dialog); // 增加类型

export default IDialog;
